import request from 'graphql-request';
import { IResponseData } from '../../../typings/common';
import { Endpoint } from '../../endpoint';
import { graphql } from '../../../gql/api-ai-tools/gql';
import type {
  TrackFreeSmartGenResolverMutation,
  TrackFreeSmartGenResolverMutationVariables,
} from '../../../gql/api-ai-tools/graphql';

const mutation = graphql(/* GraphQL */ `
  mutation TrackFreeSmartGenResolver {
    trackFreeSmartGenResolver {
      code
      message
    }
  }
`);

export const trackFreeSmartGeneration = async (): Promise<
  IResponseData<null>
> => {
  const response = await request<
    TrackFreeSmartGenResolverMutation,
    TrackFreeSmartGenResolverMutationVariables
  >(Endpoint.GRAPHQL_EDUSSON_AI_TOOL, mutation);

  const {
    trackFreeSmartGenResolver: { code, message },
  } = response;

  return {
    data: null,
    status: code,
    message,
  };
};
